import { isImmutable } from 'immutable';
import { isNil } from 'lodash';
import { FormattedMessage } from 'react-intl';

/**
 * Given a string – renders that string. Given an objects with a
 * "translationId" property – render the translated value.
 */
const MaybeTranslation = (props) => {
  const { renderedValue } = props;

  if (isNil(renderedValue)) {
    return '';
  }

  if (typeof renderedValue === 'object') {
    const [translationId, values] = isImmutable(renderedValue)
      ? // @ts-expect-error TS(2339): Property 'toJS' does not exist on type 'unknown'.
        [renderedValue.get('translationId'), renderedValue.get('values')?.toJS()]
      : [renderedValue.translationId, renderedValue.values];

    if (typeof translationId !== 'string') {
      return '';
    }

    return <FormattedMessage id={translationId} values={values} />;
  }

  return renderedValue;
};

export default MaybeTranslation;
